import ActionButton from 'components/ActionButton/ActionButton';
import 'style/forms.scss';

const PreviewButton = ({
  setShowPreview
}: {
  setShowPreview: (showPreview: boolean) => void;
}) => {
  return (
    <ActionButton
      variant="outlined"
      size="small"
      onClick={() => setShowPreview(true)}
      sx={{
        textTransform: 'capitalize'
      }}
      text="Preview (Web and Mobile)"
      dataTestId="checkoutPreviewButton"
    />
  );
};

export default PreviewButton;
